import React, {Fragment} from "react"
import { observer } from "mobx-react"
import Responsive                                                from "react-responsive"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ProductCount from "components/Product/ProductCount"
import PropTypes from "prop-types"
import ProductRowCartAction from "components/Product/ProductRowCartAction"
import ListActions from "components/Product/ProductRowListAction"
import { Label, Icon, Image } from "semantic-ui-react";
import shop from "shop/shop"
import OrderModel   from "shop/OrderModel";
import { buildProductLink } from "components/Product/productLink"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0
let articleOpen = 0		
//console.log("PRODUCTS ROW: ", shop.cart.products)
const ProductRowDefault = observer( ( {success, accountPage, readOnly, product, onChange, list, cart, rahmenauftrag  } ) => {
  let pageSize = 20
  let start = current
  current = current + pageSize
  let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
  console.log("product",product, baseUrl)
  let couponsActivated = shop.cart.activeCoupons && shop.cart.activeCoupons[0]
  let cartArticle = null
  if(couponsActivated && shop.cart && shop.cart.data && shop.cart.data.products.length > 0){
    cartArticle = shop.cart.data.products.find( p => p.article_id === product.article_id )
  }
  /*shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0` )
    .then( res => {
      console.log( "FROM API", { res } )
      orders = orders.concat( res.values.map( data => new OrderModel( data ) ) )
      openPositions = []
      // find orders with Open Positions
      let orderOpen = orders.filter( order => {
      return order.positions.filter( product => {
        let hasOpen = product.open && product.open !== 0
        if ( hasOpen ) {
        openPositions.push( product )
        console.log("PRODUCT: ",product)
        console.log("OPENPOSITIONS: ",openPositions)
        if(openPositions){
          if(openPositions.length > 0){
            for(let i = 0; openPositions.length > i;i++){
              if(openPositions[i].article_nr == product.article_nr){
                articleOpen = 1
              }
            }
          }
          
        }
        }
        return hasOpen
      } ).length
      } )
      
    } )
    console.log("HASOPEN:", openPositions)
    console.log("HASOPEN:", product.article_nr)
    let articleOpen = 0		
		if(openPositions){
			if(openPositions.length > 0){
				console.log("HASOPEN:", openPositions[0].article_nr)
				console.log("HASOPEN:", product.article_nr)
				for(let i = 0; openPositions.length > i;i++){
					if(openPositions[i].article_nr == product.article_nr){
						console.log("hasopenpassig")
						articleOpen = 1
					}
				}
			}
			
		}*/
  const hasCustomVE = product && product.extras && product.extras.Z_Verpackungseinheit_Anzahl && product.extras.Z_Verpackungseinheit_Anzahl !== "1"
  return (
   
        <Fragment>
        <Responsive minWidth={shop.config.plugin.onePageCheckout ? 1300 : 900}>
        <tr>
          <td>
            <Link to={buildProductLink( product )}>
              <Image
                className="db center"
                style={{maxWidth: "50px",maxHeight: "50px", minWidth: "50px",minHeight: "50px", overflow: "hidden",objectFit: "contain"}}
                src={!success ? product.img_src_small : `${baseUrl}/shop/rest/data/images/description/${product.article_nr}/1?size=small`}
                alt=""/>
            </Link>
          </td>
          <td>
            <Link to={buildProductLink( product )}>
              <strong>{product.article_nr}</strong> <br/>
              <span className="product-title">{product.title}</span>
            </Link>
          </td>
          
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <td className="tc">
          {!accountPage && product.pinfos && product.pinfos.brutto && <div className="tr pr2"><span className="strike black-60"><Price>{product.price}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{cartArticle && cartArticle.price ? cartArticle.price : product.price}</Price></span></div>}
          {!accountPage && product.pinfos && !product.pinfos.brutto && <div className="tr pr2"><Price>{product.price}</Price></div>}
          {!accountPage && !product.pinfos && <div className="tr pr2"><Price>{product.price}</Price></div>}
          {accountPage && !product.pinfos && <div className="tr pr2"><Price>{product.price*product.unit_multi}</Price></div>}
          </td>}
                    <td className="tr">
        {!accountPage && <div  className="tc">{Math.round(product.extras.veCount ? product.extras.veCount.value ? product.extras.veCount.value.value : product.unit_multi : product.unit_multi)}  {hasCustomVE ? translate( "VE" ) : translate( "Stück" )} </div>}
        {!accountPage && <div className="tc">{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>}
        {accountPage && <div className="tc">{product.unit_multi} {hasCustomVE ? translate( "VE" ) : translate( "Stück" )} </div>}
      </td>
          <td>
            <span className="f6 tl">
              {typeof product.getNotice === "function" && product.getNotice("tiny")
                ? product.getNotice("tiny")
                : <span className={"black-40 f6"}><Icon title={"text"} name="truck" color={"green"}/></span>
              }
            </span>
          </td>
          {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
          {/*<td></td>*/}


      {/*<td><Price>{product.price * product.unit_multi}</Price></td>*/}
      {/*<td></td>*/}
      <td>
        <div className="tr fw7">
          {!readOnly ? <div>{product.pinfos && product.pinfos.brutto ? <Fragment><span className="strike black-60"><Price>{product.price * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{(cartArticle && cartArticle.price ? cartArticle.price : product.price) * product.count * product.unit_multi}</Price></span></Fragment>
           : <Price>{(cartArticle && cartArticle.price ? cartArticle.price : product.price) * product.count * product.unit_multi}</Price>}</div>

            : rahmenauftrag ? <Fragment><div>{((product.open ).toFixed())} / {product.unit_multi * product.count}</div>
          <div>{translate(`Noch ${(product.count - product.open / product.unit_multi).toFixed()} VE`)}</div></Fragment> : product.count}
        </div>
      </td>
          
          <td className="tr">
            {!readOnly ? <ProductCount product={product} onChange={onChange}/> : <div className="fw7 tr">{product.pinfos && product.pinfos.brutto ? <Fragment><span className="strike black-60"><Price>{product.price * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{(cartArticle && cartArticle.price ? cartArticle.price : product.price) * product.count * product.unit_multi}</Price></span></Fragment>
           : <Price>{(product.pinfos && product.pinfos.gc_price_brutto ? product.pinfos.gc_price_brutto : product.price) * product.count * product.unit_multi}</Price>}</div>}
          </td>
                              {/*rahmenauftrag && <td>
            {cart ? <ProductCount rahmenauftrag={rahmenauftrag} cart={cart} product={product}/> : null}
          </td>*/}
          {list && <td>
            <div className="fr"><ListActions list={list} product={product}/></div>
          </td>}
           {!readOnly && <td>
            {cart ? <ProductRowCartAction cart={cart} product={product}/> : null}
          </td>}

        </tr>
        </Responsive>
        <Responsive maxWidth={shop.config.plugin.onePageCheckout ? 1299 : 899}>
        <tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
        <td className="tl pt2 pb2">
            <Link to={buildProductLink( product )}>
              <img style={{maxWidth: "70px",maxHeight: "70px", minWidth: "70px",minHeight: "70px", overflow: "hidden",objectFit: "contain"}}
                className="pl2 db left"
                src={!success ? product.img_src_small : `${baseUrl}/shop/rest/data/images/description/${product.article_nr}/1?size=small`}
                alt=""/>
            </Link>
          </td>
            <td  className=" pr2  pt2 bb b--black-20 tr f6 v-center">
                      <Link to={buildProductLink( product )}>
              <strong>{product.article_nr}</strong> &nbsp;
              <span className="product-title">{product.title}</span>
            </Link></td>
            <td>&nbsp;</td>
          </tr>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Preis/VE:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
          {!accountPage && product.pinfos && product.pinfos.brutto && <div className="tr pr2"><span className="strike black-60"><Price>{product.price}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{cartArticle && cartArticle.price ? cartArticle.price : product.price}</Price></span></div>}
          {!accountPage && product.pinfos && !product.pinfos.brutto && <div className="tr pr2"><Price>{product.price}</Price></div>}
          {!accountPage && !product.pinfos && <div className="tr pr2"><Price>{product.price}</Price></div>}
          {accountPage && !product.pinfos && <div className="tr pr2"><Price>{product.price*product.unit_multi}</Price></div>}
          </td>
          </tr>}
          <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">      
        {!accountPage && <div  className="tr">{Math.round(product.extras.veCount ? product.extras.veCount.value ? product.extras.veCount.value.value : product.unit_multi : product.unit_multi)}  {hasCustomVE ? translate( "VE" ) : translate( "Stück" )} </div>}
        {!accountPage && <div className="tr">{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>}
        {accountPage && <div className="tr">{product.unit_multi} {hasCustomVE ? translate( "VE" ) : translate( "Stück" )} </div>}
        </td>
          </tr>
          <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Lieferbar:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">            
            <span className="f6 tr">
              {typeof product.getNotice === "function" && product.getNotice("tiny")
                ? product.getNotice("tiny")
                : <span className={"black-40 f6"}><Icon title={"text"} name="truck" color={"green"}/></span>
              }
            </span></td>
          </tr>

         {/* <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "VE:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
            <div>{product.quantities && product.quantities[0] && product.quantities[0].des ? product.quantities[0].des : translate("Stück")} </div>
            <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
            </td>
          </tr> */}
{/*          <tr className={`ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2  fw7 f5">{translate( "Menge:" )} </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
            <div>{product.count} </div>
            <div>{hasCustomVE && <span className={"black-70 f6"}>({product.extras.Z_Verpackungseinheit_Anzahl} {translate("Stück")})</span>} </div>
            </td>
          </tr> */}
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&<tr className={` ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
          <td className="pl2  fw7 f5">{!readOnly ? translate( "Summe" ) : translate( "Menge (VE)" )} : </td>
            <td  className="pr2 bb b--black-20 tr f5 fw7">
              <div className="tr fw7">
                {!readOnly ? <div>{product.pinfos && product.pinfos.brutto ? <Fragment><span className="strike black-60"><Price>{product.price * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{(cartArticle && cartArticle.price ? cartArticle.price : product.price) * product.count * product.unit_multi}</Price></span></Fragment> 
              : <Price>{(product.pinfos && product.pinfos.gc_price_brutto ? product.pinfos.gc_price_brutto : product.price) * product.count * product.unit_multi}</Price>}</div>  : product.count}
              </div>
            </td>
          </tr>}
          
          <tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="pl2 pt1 pb1 fw7 f5">{!readOnly ? translate( "Menge (VE)" ) : translate( "Summe" )}: </td>
            <td  className="pr2 pt1 pb1 bb b--black-20 tr f5">
              {!readOnly ? <div className="flex flex-row justify-end items-center">{cart ? <ProductRowCartAction cart={cart} product={product}/> : null}<ProductCount product={product} onChange={onChange}/></div> 
              : <div className="fw7 tr">{product.pinfos && product.pinfos.brutto ? <Fragment><span className="strike black-60"><Price>{product.price * product.count * product.unit_multi}</Price></span><br/><span className="red fw6 pb2 tr"><Price>{(cartArticle && cartArticle.price ? cartArticle.price : product.price) * product.count * product.unit_multi}</Price></span></Fragment> 
              : <Price>{(product.pinfos && product.pinfos.gc_price_brutto ? product.pinfos.gc_price_brutto : product.price) * product.count * product.unit_multi}</Price>}</div>}</td>
          </tr>
          {/*<tr className={` ProductRowDefReturnMobileRight step ${(product.count-1) > 0 && "inCart"}`}>
                                          rahmenauftrag && <td colSpan={2} className="pr2 pt1 pb1 bb b--black-20 tr f5">
            {cart ? <ProductCount rahmenauftrag={rahmenauftrag} cart={cart} product={product}/> : null}
          </td>
            </tr>*/}
          {/*<tr className={`  ProductRowDefReturnMobile step ${(product.count-1) > 0 && "inCart"}`}>
            <td className="bb fw7 f5 ProductRowDefReturnMobileLeft">
            {translate( "UVP:" )}
            </td >
          <td className="tr b--black-20 bb ProductRowDefReturnMobileRight">
            <Price>{product.price * (product.count-1)}</Price>
            </td>
          </tr>*/}
        </Responsive>
        </Fragment>
  )
} )
export default ProductRowDefault

ProductRowDefault.propTypes = {
  index   : PropTypes.any,
  list    : PropTypes.object,
  cart    : PropTypes.object,
  onChange: PropTypes.func,
  product : PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Product/ProductRowDefault.js